export interface NumberRange {
  min?: number;
  max?: number;
}

const FORMAT = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 6, useGrouping: false });

export const sanitizeNumberText = (raw: string, decimals: number, allowNegative = false): string => {
  const sign = allowNegative && raw.trimStart().startsWith('-') ? '-' : '';
  const allowed = raw.replace(decimals > 0 ? /[^\d.,]/g : /\D/g, '');
  if (decimals === 0) return sign + allowed;
  const sep = allowed.search(/[.,]/);
  if (sep < 0) return sign + allowed;
  const whole = allowed.slice(0, sep);
  const fraction = allowed.slice(sep + 1).replace(/[.,]/g, '').slice(0, decimals);
  return `${sign}${whole}${allowed[sep]}${fraction}`;
};

export const parseNumberText = (text: string): number | null => {
  const normal = text.replace(',', '.');
  if (normal === '' || normal === '.' || normal === '-' || normal === '-.') return null;
  const n = Number(normal);
  return Number.isFinite(n) ? n : null;
};

export const formatNumberText = (value: number | null): string =>
  value === null || !Number.isFinite(value) ? '' : FORMAT.format(value).replace('−', '-');

export const numberRangeError = (value: number | null, range: NumberRange): string | null => {
  if (value === null) return null;
  const { min, max } = range;
  const tooLow = min !== undefined && value < min;
  const tooHigh = max !== undefined && value > max;
  if (!tooLow && !tooHigh) return null;
  if (min !== undefined && max !== undefined) {
    return `От ${formatNumberText(min)} до ${formatNumberText(max)}`;
  }
  return min !== undefined ? `Не меньше ${formatNumberText(min)}` : `Не больше ${formatNumberText(max ?? 0)}`;
};

export const numberIsValid = (value: number | null, range: NumberRange = {}): value is number =>
  value !== null && numberRangeError(value, range) === null;

export const sameNumber = (a: number | null, b: number | null): boolean =>
  a === b || (a !== null && b !== null && Math.abs(a - b) < 1e-9);
